import React from 'react';

import { Flex, Row } from 'antd';

import { DetailField, LabelPreview } from './ParcelDetailsSummary';

interface IReturnCarrierSummaryProps {
  carrier?: string;
  weightInGrams: string;
  trackingCode: string;
  labelUrl?: string | null;
}

const ReturnCarrierSummary = ({
  carrier = '-',
  weightInGrams,
  trackingCode,
  labelUrl,
}: IReturnCarrierSummaryProps) => (
  <Flex justify="space-between" align="flex-start">
    <Row gutter={[24, 8]}>
      <DetailField label="Return carrier" value={carrier} />
      <DetailField label="Tracking code" value={trackingCode || '-'} />
      <DetailField
        label="Weight"
        value={weightInGrams ? `${weightInGrams} kg` : '0 kg'}
      />
    </Row>
    {labelUrl && <LabelPreview url={labelUrl} />}
  </Flex>
);

export { ReturnCarrierSummary };
